module.exports = __webpack_public_path__ + "img/saveSVG.2f8ede03.svg";